<div class="content">
  <!-- Begin dashboard -->
  <div class="container-fluid" style="max-height: 860px;">
    <!-- Page Heading -->
    <div class="row">
      <div class="col d-flex align-items-center justify-content-between mb-4">
        <h1 class="dashboard-title">User Creation</h1>
      </div>
    </div>

    <!-- Content Row -->
    <div class="row">
      <div class="col-12  d-flex align-items-center justify-content-between pb-2">
        <!-- Search Box -->
        <div class="col-lg-9 col-md-8 ">
          <div class="google-search-container">

            <i class="fa fa-search search-icon"></i>

            <input
              (keyup)="handleKeyUp($event)"
              [(ngModel)]="searchText"
              #searchBox
              class="google-search-input"
              type="text"
              placeholder="Search User..."
            />

            <i
              *ngIf="searchBox.value"
              class="fa fa-times clear-icon"
              (click)="clearSearch(searchBox)"
            ></i>

          </div>
        </div>

        <!-- Filter and Add Buttons -->
        <div class="col-lg-3 col-md-4 d-flex justify-content-end">
          <div class="btn-group btn-group-toggle" data-toggle="buttons">
            <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchData(2)">
              Active
            </button>
            <button class="btn btn-danger" (click)="_fetchData(3)"> Inactive</button>
            <button class="btn btn-secondary active" (click)="_fetchData(1)"> All</button>
          </div>&nbsp;&nbsp;
          <button *ngIf="this.authService.hasRole('client-edit')" class="btn btn-primary btn-add-patient" type="button" routerLink="creation" title="Add Patient">
            <i class="fas fa-plus"></i><span class="btn-label">Add User</span>
          </button>
        </div>
      </div>

      <!-- Table -->
      <div class="col-12">
          <div class="table-panel p-4">
            <div class="table-responsive table-scroll-x">
              <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                <thead>
                <tr>
                  <th scope="col">Sr.No</th>
                  <th mat-sort-header="firstName" scope="col">First Name</th>
                  <th mat-sort-header="lastName" scope="col">Last Name</th>
                  <th mat-sort-header="email" scope="col">Email</th>
                  <th mat-sort-header="dob" scope="col">DOB</th>
                  <th mat-sort-header="userType" scope="col">User-Type</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody *ngFor="let table of tableData| filter: searchText; let i = index">
                <tr>
                  <th scope="row">{{i + 1}}</th>
                  <td [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id]:null">{{table.firstName ? table.firstName : '-'}}</td>
                  <td>{{table.lastName ? table.lastName : '-'}}</td>
                  <td>{{table.email ? table.email : '-'}}</td>
                  <td>{{table.dob ? table.dob : '-'}}</td>
                  <td>{{table.userType ? table.userType : '-'}}</td>
                  <!--<td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                              style="color: #34ce57"></i></td>
                  <td *ngIf="!table.active"><i class="fa-solid fa-square-check "
                                               style="color: #dc3545"></i></td>-->
                  <td>
                    <a title="Edit" [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id] : null"><i class="fa-solid fa-user-pen"></i></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a title="Delete" (click)="deleteEntry(table.id)"><i class="fa-regular fa-trash-can text-danger"></i></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a title="Reset-Password" (click)="openModal(table.userName)"><i class="fa-solid fa-key"></i><i class="fa-solid"></i></a>
                  </td>
                </tr>
                </tbody>
                <tbody *ngIf="tableData == null || tableData?.length == 0">
                <tr>
                  <td colspan="7" class="text-center"> No record found !</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="tableData?.length !== 0" class="d-flex justify-content-end mt-3">
              <mat-paginator
                [length]="totalRecord"
                [pageIndex]="pagination.currentPage"
                [pageSize]="pagination.size"
                [pageSizeOptions]="[5, 10, 25, 100]"
                aria-label="Select page"
                showFirstLastButtons
                color="warn"
                (page)="pageChange($event)">
              </mat-paginator>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>

<div #resetPassword class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Reset Password</h3>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="resetPasswordForm">
          <div class="row">
            <div class="col-xl-12 col-md-12 ">
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>User-Name</mat-label>
                  <input matInput formControlName="userName" minlength="3" pmNoSpace
                         title="Name at least has 3 characters !">
                  <mat-error *ngIf="resetPasswordForm.controls.userName.errors?.required">This field
                    is required !
                  </mat-error>
                  <mat-error *ngIf="resetPasswordForm.controls.userName?.value">Name at least has 3
                    characters !
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <!--<div class="col-xl-12 col-md-12 ">
                <div class="form-group">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Current Password</mat-label>
                        <input matInput [type]="hidePassword ? 'password' : 'text'"
                               formControlName="currentPassword" pmNoSpace pmPasswordPattern
                               placeholder="Enter Password">
                        <button *ngIf="resetPasswordForm.controls.currentPassword.value" mat-icon-button
                                matSuffix type="button" (click)="togglePasswordVisibility(1)">
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error *ngIf="resetPasswordForm.controls.currentPassword.errors?.required">
                            This field is required!
                        </mat-error>
                        <mat-error *ngIf="resetPasswordForm.controls.currentPassword.errors?.pattern">
                            Password must be at least 8 characters, contain an uppercase letter, a lowercase
                            letter, a number, and a special character.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>-->
            <div class="col-xl-12 col-md-12 ">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>New Password</mat-label>
                  <input matInput [type]="hideNewPassword ? 'password' : 'text'"
                         formControlName="newPassword" pmNoSpace pmPasswordPattern
                         placeholder="Enter Password">
                  <button *ngIf="resetPasswordForm.controls.newPassword.value" mat-icon-button
                          matSuffix type="button" (click)="togglePasswordVisibility(2)">
                    <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="resetPasswordForm.controls.newPassword.errors?.required">
                    This field is required!
                  </mat-error>
                  <mat-error *ngIf="resetPasswordForm.controls.newPassword.errors?.pattern">
                    Password must be at least 8 characters, contain an uppercase letter, a lowercase
                    letter, a number, and a special character.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-xl-12 col-md-12 ">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Confirm Password</mat-label>
                  <input matInput [type]="hideConfirmPassword ? 'password' : 'text'"
                         formControlName="confirmPassword" pmNoSpace pmPasswordPattern
                         placeholder="Enter Password">
                  <button *ngIf="resetPasswordForm.controls.confirmPassword.value" mat-icon-button
                          matSuffix type="button" (click)="togglePasswordVisibility(3)">
                    <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="resetPasswordForm.controls.confirmPassword.errors?.required">
                    This field is required!
                  </mat-error>
                  <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.invalid">
                    Password must match.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="onSubmit()">Reset</button>
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>
</div>
